import * as React from "react"
import {Box} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import ProductsMatcherTargetActionsZoom from "./Zoom";
import ProductsMatcherTargetActionsPagination from "./Pagination";


export default function ProductsMatcherTargetActions({ targetIndex, handleChangeIndex, isLoadingMapping }) {

	return <CardSeeker sx={{ width: 1}} contentProps={{ sx: { display: 'flex', justifyContent: 'space-between' } }}>
		<ProductsMatcherTargetActionsZoom />

		<ProductsMatcherTargetActionsPagination
			number={targetIndex}
			setNumber={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
		/>

		<Box />
	</CardSeeker>
}